/**
 * Project shown for a task event (label, path, colour, project filter).
 *
 * A linked task belongs to several projects (task.projects). In a calendar scoped to projects, the event shows
 * the task's main project if it is in scope, otherwise the first task project in scope. Without a scope
 * (or no match) it is the main project, as before.
 */
export function calendar_getTaskEventProjectId(task: any, scopeProjectIds?: ID[]): ID {
    if (
        _.isEmpty(scopeProjectIds)
        || _.includes(scopeProjectIds, task.projectId)
    ) {
        return task.projectId
    }

    const scopedProjectItem = _.find(task.projects, (projectItem: any) => {
        return _.includes(scopeProjectIds, projectItem.projectId)
    })

    return scopedProjectItem ? scopedProjectItem.projectId : task.projectId
}

/**
 * Calendar scope: the given projects and all their sub folders (same as RelevanceSettings.projects).
 */
export function calendar_getScopeProjectIds(projectIds: ID[] | undefined): ID[] {
    const res = _.flatMap(projectIds, (projectId: ID) => {
        return [projectId].concat(_.map(gd.session.projects.getAllChildrenOptimized(projectId), (project: any) => {
            return project.id
        }))
    })

    return _.uniq(res)
}
